import { createContext, useContext } from 'react';
import type { MentionCandidate } from './mention-types';

/**
 * React context that feeds @mention candidates INTO the lazy editor bundle.
 *
 * Before the lexical lib-layer split, `MentionPlugin` called the Redux hook
 * `useMentionCandidates()` directly. That hook reads the store + WA thunks, so
 * it CANNOT live inside the lazy bundle (it would duplicate the store/thunk
 * singletons and break Redux). Instead, the app-side host component calls the
 * hook and passes the result down through this context; `MentionPlugin` (in the
 * bundle) consumes it via `useMentionCandidatesContext()`.
 *
 * The context itself is coupling-free (React only), so it is safe to import from
 * both the app graph and the lazy bundle.
 */
export interface MentionData {
  candidates: MentionCandidate[];
  isLoading: boolean;
}

export const MentionCandidatesContext = createContext<MentionData>({
  candidates: [],
  isLoading: false,
});

export const useMentionCandidatesContext = (): MentionData =>
  useContext(MentionCandidatesContext);
